module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_0.e7cc0b00.png";